import { jsxs as a, jsx as p } from "react/jsx-runtime";
import "@material-ui/core/Box";
import "@material-ui/core/Breadcrumbs";
import "@material-ui/core/Button";
import "@material-ui/core/Card";
import "@material-ui/core/CardContent";
import "@material-ui/core/Checkbox";
import e from "@material-ui/core/CircularProgress";
import "@material-ui/core/Dialog";
import "@material-ui/core/DialogActions";
import "@material-ui/core/DialogContent";
import "@material-ui/core/DialogContentText";
import "@material-ui/core/DialogTitle";
import "@material-ui/core/Divider";
import "@material-ui/core/Drawer";
import "@material-ui/core/FormControl";
import "@material-ui/core/FormControlLabel";
import "@material-ui/core/FormGroup";
import "@material-ui/core/FormHelperText";
import "@material-ui/core/Grid";
import "@material-ui/core/IconButton";
import "@material-ui/core/Input";
import "@material-ui/core/InputAdornment";
import "@material-ui/core/InputBase";
import "@material-ui/core/InputLabel";
import "@material-ui/core/LinearProgress";
import "@material-ui/core/Link";
import "@material-ui/core/ListItemIcon";
import "@material-ui/core/ListItemText";
import "@material-ui/core/Menu";
import "@material-ui/core/MenuItem";
import "@material-ui/core/Modal";
import "@material-ui/core/Popover";
import "@material-ui/core/Radio";
import "@material-ui/core/RadioGroup";
import "@material-ui/core/Select";
import "@material-ui/core/styles/createStyles";
import "@material-ui/core/styles/createTheme";
import n from "@material-ui/core/styles/makeStyles";
import "@material-ui/core/styles/useTheme";
import "@material-ui/core/styles/withStyles";
import "@material-ui/core/styles/withTheme";
import "@material-ui/core/SvgIcon";
import "@material-ui/core/Table";
import "@material-ui/core/TableBody";
import "@material-ui/core/TableCell";
import "@material-ui/core/TableContainer";
import "@material-ui/core/TableHead";
import "@material-ui/core/TableRow";
import "@material-ui/core/TextField";
import "@material-ui/core/Tooltip";
import "@material-ui/core/Typography";
import "@material-ui/core/useMediaQuery";
import "@material-ui/icons/Check";
import "@material-ui/icons/CheckCircle";
import "@material-ui/icons/Clear";
import "@material-ui/icons/Close";
import "@material-ui/icons/Delete";
import "@material-ui/icons/Error";
import "@material-ui/icons/FiberManualRecord";
import "@material-ui/icons/HelpOutline";
import "@material-ui/icons/Home";
import "@material-ui/icons/Info";
import "@material-ui/icons/KeyboardArrowLeft";
import "@material-ui/icons/KeyboardArrowRight";
import "@material-ui/icons/NavigateNext";
import "@material-ui/icons/OpenInNew";
import "@material-ui/icons/ReportProblem";
import "@material-ui/icons/Schedule";
import "@material-ui/icons/Visibility";
import "@material-ui/icons/VisibilityOff";
import "@material-ui/icons/Warning";
import "@material-ui/lab/Alert";
import "@material-ui/pickers/DatePicker";
import "@material-ui/pickers/MuiPickersUtilsProvider";
import "@material-ui/styles/ThemeProvider";
const c = n({
  root: {
    position: "relative",
    marginLeft: "auto",
    marginRight: "auto",
    fontSize: "unset !important"
  },
  bottom: {
    opacity: 0.25
  },
  top: {
    animationDuration: "550ms",
    position: "absolute"
  }
}), l = 48, u = (t) => typeof t == "string" ? t === "small" ? 16 : 48 : typeof t == "number" ? t : l, It = ({ className: t, style: s, ...o }) => {
  const r = c(), i = u(o.size), m = {
    size: i,
    thickness: 7
  };
  return /* @__PURE__ */ a(
    "div",
    {
      "data-testid": "circular-progress",
      className: r.root,
      style: { width: i, height: i, ...s || {} },
      children: [
        /* @__PURE__ */ p(
          e,
          {
            "data-testid": "cp-bottom",
            variant: "determinate",
            className: `${r.bottom} ${t ?? ""}`,
            ...o,
            ...m,
            value: 100
          }
        ),
        /* @__PURE__ */ p(
          e,
          {
            "data-testid": "cp-top",
            variant: "indeterminate",
            disableShrink: !0,
            className: `${r.top} ${t ?? ""}`,
            ...o,
            ...m,
            style: { left: 0 }
          }
        )
      ]
    }
  );
};
export {
  It as default
};
//# sourceMappingURL=CircularProgress.js.map
